<template>
  <DialogPortal>
    <DialogOverlay
      class="fixed inset-0 z-50 bg-[#00000072] data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 grid items-start justify-center overflow-y-auto py-5 md:py-40"
    >
      <DialogContent
        :class="
          cn([
            'relative z-50',
            'grid w-full xs:max-w-xs sm:max-w-md md:max-w-max lg:max-w-max',
            'bg-primary-700 rounded-lg shadow-lg text-neutral-300',
          ])
        "
        v-bind="{ ...props, ...emitsAsProps }"
      >
        <slot />

        <DialogClose
          class="absolute top-4 right-6 p-1 transition-colors rounded-md hover:bg-secondary-400"
          aria-label="Cancel"
        >
          <X class="w-6 h-6" />
          <span class="sr-only">Close</span>
        </DialogClose>
      </DialogContent>
    </DialogOverlay>
  </DialogPortal>
</template>

<script setup>
import {
  DialogClose,
  DialogContent,
  DialogOverlay,
  DialogPortal,
  useEmitAsProps,
} from 'radix-vue';
import { X } from 'lucide-vue-next';
import { cn } from '../../utils.js';

const props = defineProps({
  forceMount: {
    type: Boolean,
    required: false,
    default: false,
  },
  trapFocus: {
    type: Boolean,
    required: false,
    default: false,
  },
  class: {
    type: String,
    default: '',
  },
});
const emits = defineEmits([
  'interactOutside',
  'escapeKeyDown',
  'pointerDownOutside',
  'focusOutside',
  'dismiss',
]);

const emitsAsProps = useEmitAsProps(emits);
</script>
